import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Breadcrumb from "../components/Breadcrumb";
import SectionLabel from "../components/SectionLabel";
import ScrollReveal from "../components/ScrollReveal";
import { SERVICES } from "../lib/data";

export default function ServicesOverview() {
  return (
    <div className="page" data-testid="services-page">
      <section className="page-hero">
        <div className="container-x">
          <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Services", to: "/services" }]} />
          <h1 style={{ marginTop: 16 }}>Creative Services.</h1>
          <p className="lead">Everything your brand needs — from a single sharp logo to an end-to-end design system.</p>
        </div>
      </section>

      <section className="section section-bright">
        <div className="container-x">
          <SectionLabel num={1}>Practices</SectionLabel>
          <h2 className="sec-title">Five practices, one studio.</h2>

          <div className="svc-grid-main" style={{ marginTop: 48 }}>
            {SERVICES.map((s, i) => (
              <ScrollReveal key={s.slug} delay={i * 80}>
                <Link to={`/services/${s.slug}`} className="svc-card-large" data-testid={`svc-overview-${s.slug}`}>
                  <h3>{s.title}</h3>
                  <div className="sub-list">{s.sublist.map((x) => <span key={x}>{x}</span>)}</div>
                  <p>{s.short}</p>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 12, flexWrap: "wrap", gap: 12 }}>
                    <div className="proj-byline">Starting from {s.starting}</div>
                    <span className="learn-link">Explore Service <ArrowRight size={14} /></span>
                  </div>
                </Link>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section-platinum">
        <div className="container-x">
          <SectionLabel num={2}>Pricing Overview</SectionLabel>
          <h2 className="sec-title">Transparent pricing across all our practices.</h2>
          <p className="sec-sub">Packages tailored to scale with your business needs.</p>
          
          <div style={{ display: "flex", flexDirection: "column", gap: "80px", marginTop: "48px" }}>
            {SERVICES.map((service, index) => (
              <div key={service.slug}>
                <h3 style={{ fontSize: "32px", fontWeight: "700", marginBottom: "32px", letterSpacing: "-0.02em" }}>{service.title}</h3>
                <div className="pricing-table-wrapper">
                  <table className="pricing-table">
                    <thead>
                      <tr>
                        <th className="empty-corner"></th>
                        {service.pricing.map(p => (
                          <th key={p.tier} className={p.featured ? "featured-col" : ""}>
                            <div className="th-content">
                              {p.tier}
                              {p.featured && <span className="table-featured-badge">Popular</span>}
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="row-label">Price</td>
                        {service.pricing.map(p => (
                          <td key={p.tier} className={`price-cell ${p.featured ? "featured-col" : ""}`}>
                            <div className="price-val">{p.price}</div>
                            <div className="price-sub">{p.price !== "Custom Quote" && p.price !== "Custom" ? "starting from" : "tailored quote"}</div>
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="row-label">Delivery</td>
                        {service.pricing.map(p => (
                          <td key={p.tier} className={p.featured ? "featured-col" : ""}>{p.delivery}</td>
                        ))}
                      </tr>
                      <tr>
                        <td className="row-label">Included Features</td>
                        {service.pricing.map(p => (
                          <td key={p.tier} className={`features-cell ${p.featured ? "featured-col" : ""}`}>
                            <ul>
                              {p.inc.map(x => (
                                <li key={x}><Check size={14} className="check-icon" /> <span>{x}</span></li>
                              ))}
                            </ul>
                          </td>
                        ))}
                      </tr>
                      <tr>
                        <td className="row-label"></td>
                        {service.pricing.map(p => (
                          <td key={p.tier} className={`action-cell ${p.featured ? "featured-col" : ""}`}>
                            <Link to="/contact" className={`btn ${p.featured ? 'btn-primary' : 'btn-outline'}`}>
                              Get Started <ArrowRight size={14} />
                            </Link>
                          </td>
                        ))}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="container-x" style={{ marginTop: "64px" }}>
        <div className="cta-dark">
          <div className="lead">Not sure which?</div>
          <h2>Let's chat about what your project actually needs.</h2>
          <Link to="/contact" className="btn btn-light">Get In Touch <ArrowRight size={16} /></Link>
        </div>
      </div>
    </div>
  );
}
